import React, { useState } from 'react';
import { EGerdauHomeContainer } from '../../components/EGerdauHome/styles';
import logoGerdauMais from '../../assets/images/logo_gerdau_mais.svg';
import { PasswordRules, FormCard, CheckIcon, CloseIcon } from './styles';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { Button, Checkbox, Form, Input } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { UserService } from '../../services/User';
import { useDispatch } from 'react-redux';
import { addToast } from '../../store/ducks/toast/actions';
import { EToastTypes } from '../../store/ducks/toast/types';

const FirstLogin: React.FC<RouteComponentProps> = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [userAcceptNotification, setUserAcceptNotification] = useState(false);

  const [loading, setLoading] = useState(false);

  const getUserId = (): string => {
    const query = new URLSearchParams(props.location.search);
    const uid = query.get('uid') as string;
    if (!uid) {
      history.push('/');
    }
    return uid;
  };

  const [userId] = useState(getUserId());

  const sendPassword = () => {
    setLoading(true);
    const userSvc = new UserService();

    userSvc
      .createPassword(userId, password, userAcceptNotification)
      .then(() => {
        setLoading(false);
        dispatch(
          addToast({
            type: EToastTypes.SUCCESS,
            message: 'Senha criada com sucesso. Redirecionando para login...'
          })
        );
        setTimeout(() => {
          userSvc.logout();
        }, 1000);
      })
      .catch(() => {
        setLoading(false);
        dispatch(
          addToast({
            type: EToastTypes.DANGER,
            message:
              'Não foi possível criar a senha. Tente novamente mais tarde, se o erro persistir, procure o seu vendedor.'
          })
        );
      });
  };

  const isPasswordEqualConfirm = () => {
    return password !== '' && password === passwordConfirm;
  };

  const has8DigitsOrMore = (): boolean => {
    return password.length >= 8;
  };

  const hasUppercaseLetter = (): boolean => {
    const regexExp = new RegExp(/[A-Z]/g);
    return regexExp.test(password);
  };

  const hasLowerCaseLetter = (): boolean => {
    const regexExp = new RegExp(/[a-z]/g);
    return regexExp.test(password);
  };

  const hasNumber = () => {
    const regexExp = new RegExp(/[0-9]/g);
    return regexExp.test(password);
  };

  const hasSpecialCharacter = (): boolean => {
    const regexExp = new RegExp(/[^a-zA-Z0-9-_]/g);
    return regexExp.test(password);
  };

  const canSendPassWord = (): boolean => {
    return (
      isPasswordEqualConfirm() &&
      has8DigitsOrMore() &&
      hasUppercaseLetter() &&
      hasLowerCaseLetter() &&
      hasNumber() &&
      hasSpecialCharacter()
    );
  };

  return (
    <EGerdauHomeContainer>
      <FormCard>
        <header>
          <img src={logoGerdauMais} alt="logo Gerdau" />
        </header>

        <PasswordRules>
          <header>
            <h2 className="title">Bem vindo ao GERDAU mais!</h2>
            <p className="sub-title">Vamos criar a sua senha de acesso.</p>
          </header>

          <div className="content">
            <span>Sua senha deve conter:</span>
            <ul>
              <li>
                Letra maiúscula{' '}
                {hasUppercaseLetter() ? <CheckIcon /> : <CloseIcon />}
              </li>
              <li>
                Letra minúscula{' '}
                {hasLowerCaseLetter() ? <CheckIcon /> : <CloseIcon />}
              </li>
              <li>Número {hasNumber() ? <CheckIcon /> : <CloseIcon />}</li>
              <li>
                Caracter Especial{' '}
                {hasSpecialCharacter() ? <CheckIcon /> : <CloseIcon />}
              </li>
              <li>
                No mínimo 8 dígitos{' '}
                {has8DigitsOrMore() ? <CheckIcon /> : <CloseIcon />}
              </li>
              <li>
                As senhas devem ser iguais{' '}
                {isPasswordEqualConfirm() ? <CheckIcon /> : <CloseIcon />}
              </li>
            </ul>
          </div>
        </PasswordRules>

        <Form
          id="first-login-form"
          onFinish={sendPassword}
          layout="vertical"
          initialValues={{
            password,
            passwordConfirm,
            userAcceptNotification
          }}
        >
          <Form.Item name="password" label="Senha">
            <Input.Password
              placeholder="Digite a senha"
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
            />
          </Form.Item>

          <Form.Item name="passwordConfirm" label="Confirme a senha">
            <Input.Password
              placeholder="Confirme a senha"
              onChange={(e) => setPasswordConfirm(e.target.value)}
              disabled={loading}
            />
          </Form.Item>

          <Form.Item name="userAcceptNotification" valuePropName="checked">
            <Checkbox
              className="userAcceptNotification"
              onChange={(e: CheckboxChangeEvent) =>
                setUserAcceptNotification(e.target.checked)
              }
              disabled={loading}
            >
              Aceito receber emails de comunicação sobre as novidades do Gerdau
              mais
            </Checkbox>
          </Form.Item>

          <Form.Item name="userPrivacyAccept">
            Ao continuar,{' '}
            <a
              href="https://mais.gerdau.com.br/politica-de-privacidade-e-termos-de-uso"
              target="_blank"
            >
              você concorda com a Política de Privacidade e Termos de Uso.
            </a>
          </Form.Item>

          <div className="actions">
            <Button
              type="primary"
              htmlType="submit"
              disabled={loading || !canSendPassWord()}
              loading={loading}
            >
              Criar senha
            </Button>
          </div>
        </Form>
      </FormCard>
    </EGerdauHomeContainer>
  );
};

export default FirstLogin;
